import { render, staticRenderFns } from "./the-menu.vue?vue&type=template&id=05fbdbec&scoped=true&"
import script from "./the-menu.vue?vue&type=script&lang=js&"
export * from "./the-menu.vue?vue&type=script&lang=js&"
import style0 from "./the-menu.vue?vue&type=style&index=0&id=05fbdbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbdbec",
  null
  
)

export default component.exports